import type { Site } from 'site/types';

export function prependCountryAndLocale(
  path: string,
  site: Pick<Site, 'countryInPath'>
): string {
  const locale = __LOCALE__;

  if (site.countryInPath === null) {
    return path;
  } else {
    return ['/', site.countryInPath, '/', locale, path].join('');
  }
}
